const initialState = {
  pubList: [],
};

export default function PubReducer(state = initialState, actions) {
  if (actions.type === "LIST_PUB") {
    const pubs = [...actions.payload];

    return {
      pubList: pubs,
    };
  }

  return state;
}
